export default __webpack_public_path__ + "static/media/dolar.568308ab.svg";